import tableRelatedAppPackages from './tableRelatedAppPackages';

export default {
  title: 'V.T. Providers',
  attributeName: 'appPacakges',
  getURL: 'appId/appPackage/noSKU',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableRelatedAppPackages,
};
